/*
 * Scentt: copies Trade's routes and UI strings from the JSON data block #scentt-globals
 * onto window.* (where Trade's own scripts expect them). Keeping the values in a
 * non-executable JSON block means no Liquid output ever runs as JavaScript.
 * Loaded without defer, right after the data block, so the values exist before any
 * deferred script runs \u2013 the same timing as Trade's original inline script.
 */
(function () {
  'use strict';
  var el = document.getElementById('scentt-globals');
  var data = {};
  try {
    data = JSON.parse(el ? el.textContent : '{}') || {};
  } catch (e) {
    data = {};
  }
  var keys = ['routes', 'cartStrings', 'variantStrings', 'quickOrderListStrings', 'accessibilityStrings'];
  keys.forEach(function (k) {
    var v = data[k];
    window[k] = v && typeof v === 'object' && !Array.isArray(v) ? v : {};
  });
  window.shopUrl = typeof data.shopUrl === 'string' ? data.shopUrl : window.location.origin;
})();
